import { useMemo } from 'react'
import { useAuth } from '~/api/auth'

const useCanEdit = () => {
  const { user } = useAuth()

  return useMemo(() => Boolean(user?.can_edit), [user?.can_edit])
}

export default useCanEdit
